import React, { useEffect, type ReactNode } from 'react';
import { useRouter } from 'next/router';
import enMessagesPromise from '@/locales/en/messages';
import esMessagesPromise from '@/locales/es/messages';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { enUS, es as esDate } from 'date-fns/locale';
import setDefaultOptions from 'date-fns/setDefaultOptions';

export const locales = {
  es: { messages: esMessagesPromise },
  en: { messages: enMessagesPromise },
} as const;

export type LocaleCode = keyof typeof locales;

type IntlProps = { children: ReactNode | undefined };

async function loadI18n(locale: string) {
  // fix this error Module not found: Can't resolve './src/locales'
  // const messages = await import(`@/locales/${locale}/messages`)

  // i18n.load(locale, messages);
  // i18n.activate(locale);

  const {
    messages: { messages },
  } = locales[locale as LocaleCode];
  setDefaultOptions({ locale: locale === 'es' ? esDate : enUS });
  i18n.load(locale, messages);
  i18n.activate(locale);
}

const IntlProvider = ({ children }: IntlProps) => {
  const { locale } = useRouter();

  useEffect(() => {
    loadI18n(locale || i18n.locale);
  }, [locale]);

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
};

export default IntlProvider;
